import { defaultRouterMap, permissionRouterMap } from '@/router'

const routersName = []

const permission = {
    state: {
        addRouters: [],
        routers: [],
        routersName: [],
        workground: false,
        proWorkground: []
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers
            state.routers = defaultRouterMap.concat(routers)
        },
        SET_ROUTERS_NAME: (state, names) => {
            state.routersName = names
        },
        SET_WORKGROUND: (state, workground) => {
            state.workground = workground.length ? workground : false
        },
        SET_PRO_WORKGROUND: (state, workground) => {
            state.proWorkground = workground || []
        }
    },
    actions: {
        GenerateRoutes ({ commit }, { roles, sellerWorkground, proWorkground }) {
            return new Promise(resolve => {
                let accessedRouters = filterPermissionRouter(permissionRouterMap, roles)
                // 角色权限
                if (sellerWorkground.length) {
                    accessedRouters = filterPermissionRouter(accessedRouters, sellerWorkground, hasPermissionWork)
                }

                commit('SET_ROUTERS', accessedRouters)
                commit('SET_ROUTERS_NAME', routersName)
                commit('SET_WORKGROUND', sellerWorkground)
                commit('SET_PRO_WORKGROUND', proWorkground)
                resolve()
            })
        }
    }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 *
 * @param asyncRouterMap
 * @param roles
 *
 */
function filterPermissionRouter (permissionRouter, roles, veryMethod = hasPermission) {
    const accessedRouters = permissionRouter.filter(route => {
        if (veryMethod(roles, route)) {
            route.name && routersName.push(route.name)
            if (route.children && route.children.length) {
                route.children = filterPermissionRouter(route.children, roles, veryMethod)
            }
            return true
        } else {
            return false
        }
    })

    return accessedRouters
}

/**
 * 通过meta.role判断是否与当前用户权限匹配
 *
 * @param roles
 * @param route
 *
 */
function hasPermission (roles, route) {
    if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.indexOf(role) >= 0)
    } else {
        return true
    }
}

function hasPermissionWork (workground, route) {
    if (route.meta && route.meta.workName) {
        const workName = route.meta.workName
        return workground.some(name => typeof workName === 'string' ? name === workName : workName.indexOf(name) >= 0)
    } else {
        return true
    }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js